import React  from 'react'
import Hero from '../components/Hero'

import OfficeLocation from '../components/OfficeLocation.jsx';

const Contactus = () => {
 
  return (
    <>
     <Hero
      title="Contact by Region – Find Help Near You."
      description=""
      buttonText=""
      customClass="contactBanner"
      imageSrc="images/contactus.webp"
      squareColor="Contactsquare-bg-color"
    />
    <OfficeLocation/>
    </>
   
  )
}

export default Contactus